const pad2 = (n) => String(n).padStart(2, '0')

// Expects "YYYY-MM-DD" and returns a LOCAL Date (no UTC parsing)
const parseLocalDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null

  const parts = dateStr.split('-').map(Number)
  if (parts.length < 3) return null

  const [year, month, day] = parts
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null

  return new Date(year, month - 1, day)
}

// Parse dashboard graph month labels (YYYY-MM-DD, YYYY-MM, "Mar 2025", etc.) → first of month local, or null.
const parseGraphMonthLabel = (label) => {
  const s = String(label || '').trim()
  if (!s) return null

  const fromYmd = parseLocalDate(s)
  if (fromYmd && !Number.isNaN(fromYmd.getTime())) {
    return new Date(fromYmd.getFullYear(), fromYmd.getMonth(), 1)
  }

  const ym = /^(\d{4})-(\d{2})$/.exec(s)
  if (ym) {
    const y = Number(ym[1])
    const mo = Number(ym[2])
    if (Number.isFinite(y) && mo >= 1 && mo <= 12) return new Date(y, mo - 1, 1)
  }

  const monYear = /^([A-Za-z]{3,9})\s+(\d{4})$/.exec(s)
  if (monYear) {
    const d = new Date(`${monYear[1]} 1, ${monYear[2]}`)
    if (!Number.isNaN(d.getTime())) return new Date(d.getFullYear(), d.getMonth(), 1)
  }

  const t = Date.parse(s)
  if (!Number.isNaN(t)) {
    const d = new Date(t)
    if (!Number.isNaN(d.getTime())) return new Date(d.getFullYear(), d.getMonth(), 1)
  }

  return null
}

// Date|timestamp|string -> "YYYY-MM-DD" (LOCAL, not UTC)
const toLocalYmd = (value) => {
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return null

  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

const toMonthKey = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return ''
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}`
}

const getMonthDifference = (startDate, endDate) => {
  const startObj = startDate instanceof Date ? startDate : parseLocalDate(startDate)
  const endObj = endDate instanceof Date ? endDate : parseLocalDate(endDate)
  if (!startObj || !endObj) return 0

  return (
    (endObj.getFullYear() - startObj.getFullYear()) * 12 +
    (endObj.getMonth() - startObj.getMonth())
  )
}

export { parseLocalDate, parseGraphMonthLabel, toLocalYmd, toMonthKey, getMonthDifference }
